export function multiPartData(data){
    let multiPart = new FormData();
    for (let key in data){
      multiPart.append(key,data[key])
    }
  
    return multiPart
  }